import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

const ModalBody = ({ children, unstyled }) => (
  <div
    className={classNames('fv-modal-body', {
      'fv-modal-unstyled': unstyled
    })}
  >
    {children}
  </div>
)

ModalBody.propTypes = {
  children: PropTypes.node
}

export default ModalBody



// WEBPACK FOOTER //
// ../src/components/fv-ui/ModalBody.js